import React, { useState, useEffect, useCallback } from 'react';
import Select from 'react-select';
import { getWithTokenAPI, postWithTokenAPI, putWithTokenAPI } from '../Util/Api';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaUserCircle, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import '../Style/Component/Walletreruestcom.css';
import Swal from 'sweetalert2'; // Import SweetAlert2
const Walletreruestcom = () => {
    const [activeTab, setActiveTab] = useState('pending');
    const [withdrawals, setWithdrawals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updatingId, setUpdatingId] = useState(null);
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const auth = useSelector((state) => state.auth);
    const token = auth.token;
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [tpage, setTpage] = useState(1);
    const limit = 10;

    const statusOptions = [
        { value: 'pending', label: 'Pending', color: '#d97706', bg: '#fef3c7' },
        { value: 'approved', label: 'Approved', color: '#059669', bg: '#d1fae5' },
        { value: 'rejected', label: 'Rejected', color: '#dc2626', bg: '#fee2e2' },
    ];

    const customSelectStyles = {
        control: (base) => ({
            ...base,
            borderRadius: '20px',
            fontSize: '12px',
            fontWeight: '600',
            minHeight: '32px',
            width: '140px',
            border: '1px solid #e2e8f0',
            boxShadow: 'none',
            cursor: 'pointer',
            '&:hover': { border: '1px solid #cbd5e1' }
        }),
        option: (base, { data, isFocused }) => ({
            ...base,
            fontSize: '12px',
            fontWeight: '600',
            backgroundColor: isFocused ? data.bg : 'white',
            color: data.color,
            cursor: 'pointer',
        }),
        singleValue: (base, { data }) => ({
            ...base,
            color: data.color,
            background: data.bg,
            padding: '2px 10px',
            borderRadius: '12px',
        }),
        // This ensures the menu stays above everything
        menuPortal: (base) => ({ ...base, zIndex: 9999 })
    };

    useEffect(() => {
        const handler = setTimeout(() => setSearchTerm(searchInput), 500);
        return () => clearTimeout(handler);
    }, [searchInput]);

    const fetchWithdrawHistory = useCallback(async () => {
        if (!token) return;

        try {
            setLoading(true);

            let url = `/withdraw/history?status=${activeTab}&page=${page}&limit=${limit}`;

            if (searchTerm.trim()) {
                url += `&search=${encodeURIComponent(searchTerm.trim())}`;
            }

            const response = await getWithTokenAPI(token, url);

            setWithdrawals(response.data?.data || []);
            setTpage(response.data?.totalPages || 1);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }

    }, [activeTab, searchTerm, token, page]);

    useEffect(() => {
        fetchWithdrawHistory();
    }, [fetchWithdrawHistory]);

const handleStatusUpdate = async (id, selectedOption) => {
    const newStatus = selectedOption.value;

    let utr_number = "";
    let rejection_reason = "";
    let payout_status = "pending";

    // ---------------- APPROVED ----------------
    if (newStatus === "approved") {
        const result = await Swal.fire({
            title: "Approve Withdrawal",
            html: `
                <input
                    id="utr_number"
                    class="swal2-input"
                    placeholder="Enter UTR Number"
                />
            `,
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Approve",
            cancelButtonText: "Cancel",
            confirmButtonColor: "var(--primary)",
            cancelButtonColor: "#d33",
            preConfirm: () => {
                const utr = document
                    .getElementById("utr_number")
                    .value
                    .trim();

                if (!utr) {
                    Swal.showValidationMessage("Please enter UTR Number");
                    return false;
                }

                return utr;
            }
        });

        if (!result.isConfirmed) return;

        utr_number = result.value;
        payout_status = "success";
    }

    // ---------------- REJECTED ----------------
    if (newStatus === "rejected") {
        const result = await Swal.fire({
            title: "Reject Withdrawal",
         width: "650px",
  html: `
    <textarea
      id="rejection_reason"
      placeholder="Enter Rejection Reason"
      style="
        width:100%;
        height:120px;
        box-sizing:border-box;
        resize:none;
        padding:12px;
        font-size:16px;
        border:1px solid #d9d9d9;
        border-radius:8px;
      "
    ></textarea>
  `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Reject",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            preConfirm: () => {
                const reason = document
                    .getElementById("rejection_reason")
                    .value
                    .trim();

                if (!reason) {
                    Swal.showValidationMessage(
                        "Please enter rejection reason"
                    );
                    return false;
                }

                return reason;
            }
        });

        if (!result.isConfirmed) return;

        rejection_reason = result.value;
        payout_status = "failed";
    }

    // ---------------- PENDING ----------------
    if (newStatus === "pending") {
        payout_status = "pending";
    }

    // ---------------- CONFIRM ----------------
    const confirm = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to change the status to ${newStatus}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "var(--primary)",
        cancelButtonColor: "#d33",
    });

    if (!confirm.isConfirmed) return;

    try {
        setUpdatingId(id);

        const response = await putWithTokenAPI(
            token,
            `/withdraw/update-status/${id}`,
            {
                status: newStatus,
                payout_status,
                utr_number,
                rejection_reason,
            }
        );

        if (response.statusCode === 200) {
            fetchWithdrawHistory();

            Swal.fire({
                icon: "success",
                title: "Status Updated Successfully",
                text: `Withdrawal ${newStatus} successfully.`,
                timer: 1500,
                showConfirmButton: false,
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "Update Failed",
                text: response.message || "Something went wrong.",
            });
        }
    } catch (err) {
        console.error(err);

        Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
        });
    } finally {
        setUpdatingId(null);
    }
};

    return (
        <div className="wallet-container">
            <div className="modern-header">
                <div className="header-left">
                    <h2>Withdrawal Management</h2>
                </div>

                <div className="tabs-container">
                    <div className="tabs-header">
                        {['pending', 'approved', 'rejected'].map((tab) => (
                            <button
                                key={tab}
                                className={`tab-link ${activeTab === tab ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="custom-search-wrapper">
                    <FaSearch className="search-icon-inside" />
                    <input
                        type="text"
                        placeholder="Search Driver Name "
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                    />
                </div>
            </div>



            <div className="table-wrapper-modern-loader">
                {loading ? (
                    <div className="modern-loader">Loading...</div>
                ) : (
                    <table className="modern-table">
                        <thead>
                            <tr>
                                <th>Driver ID</th>
                                <th>Driver Profile</th>
                                <th>Contact</th>
                                <th>Amount</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {withdrawals.map((item) => (
                                <tr key={item._id}>
                                    <td className="driver-id-cell">#{item.driver?.driverId}</td>
                                    <td>
                                        <div className="profile-cell" onClick={() => navigate(`/admin/driversdata/driver/${item?.driver?._id}`)}>
                                            {/* <FaUserCircle className="user-avatar-icon" /> */}
                                            <span className="user-name">{item?.driver?.name}</span>
                                        </div>
                                    </td>
                                    <td>{item.driver?.phoneNumber}</td>
                                    <td className="amount-cell">₹{item.amount}</td>
                                    <td>{new Date(item.createdAt).toLocaleDateString('en-GB')}</td>
                                    <td>
                                        <div className="select-container-modern">
                                            <Select
                                                options={statusOptions}
                                                styles={customSelectStyles}
                                                value={statusOptions.find(opt => opt.value === item.status)}
                                                onChange={(opt) => handleStatusUpdate(item._id, opt)}
                                                isLoading={updatingId === item._id}
                                                isSearchable={false}
                                                isDisabled={updatingId === item._id}
                                                // FIX: Teleport menu to body so it's never hidden
                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="6">
                                    {tpage > 1 && (
                                        <div className="pagination">

                                            {page > 1 && (
                                                <button
                                                    className="page-btn"
                                                    onClick={() => setPage(page - 1)}
                                                >
                                                    ‹
                                                </button>
                                            )}

                                            {page > 1 && (
                                                <button
                                                    className="page-btn"
                                                    onClick={() => setPage(1)}
                                                >
                                                    1
                                                </button>
                                            )}

                                            {page > 2 && (
                                                <span className="page-dots">...</span>
                                            )}

                                            <button className="page-btn pgnoactive">
                                                {page}
                                            </button>

                                            {page < tpage - 1 && (
                                                <span className="page-dots">...</span>
                                            )}

                                            {page !== tpage && (
                                                <button
                                                    className="page-btn"
                                                    onClick={() => setPage(tpage)}
                                                >
                                                    {tpage}
                                                </button>
                                            )}

                                            {page < tpage && (
                                                <button
                                                    className="page-btn"
                                                    onClick={() => setPage(page + 1)}
                                                >
                                                    ›
                                                </button>
                                            )}

                                        </div>
                                    )}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </div>
        </div>
    );
};

export default Walletreruestcom;